import React from "react";
import {ClickableText} from "../custom-common";

const CancelLink = ({onCancel}) => (
    <ClickableText small onClick={onCancel}>or Cancel</ClickableText>
);

export default CancelLink;
